function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SloveniaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1486",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1486)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1486",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1486)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V9H24V3H0Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#C51918"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.3052 6.77716C10.3052 6.77716 8.72661 6.03171 6.76326 6.03171C4.79991 6.03171 3.22136 6.77716 3.22136 6.77716C3.22136 6.77716 3.39703 9.7732 3.67468 11.3603C3.79323 12.038 4.36303 13.0264 4.87888 13.4942C5.46686 14.0274 6.76326 14.6591 6.76326 14.6591C7.13842 14.4006 7.83986 14.2844 8.73644 13.4942C9.63302 12.704 9.85586 11.3603 9.85586 11.3603L10.3052 6.77716Z",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.0965 6.6792L10.7539 7.00749L10.3026 11.5245C10.1445 12.4805 9.74905 13.2344 9.11659 13.7918C8.7735 14.0941 8.43861 14.32 8.07956 14.5078C7.87689 14.6137 7.02913 15.0504 7.03651 15.0469C6.95158 15.0878 6.88716 15.1237 6.83485 15.1597L6.75285 15.2162L6.66432 15.1731C5.78625 14.7452 4.96702 14.1694 4.55992 13.8002C4.00418 13.2962 3.41821 12.2649 3.29329 11.5508C3.1065 10.4831 2.939 9.0124 2.82144 7.00749L3.41199 6.69854C3.52866 8.68835 3.6695 10.2745 3.85291 11.323C3.96143 11.9433 4.50177 12.8943 4.99469 13.3413C5.35899 13.6717 5.94589 14.038 6.75285 14.4364C6.80099 14.4082 6.85433 14.3803 6.91535 14.3509C6.91707 14.3501 7.46601 14.1063 7.65678 14.0065C7.99139 13.8316 8.30242 13.6218 8.62264 13.3396C9.18407 12.8448 9.53447 12.1784 9.67618 11.3319L10.0965 6.6792Z",
        fill: "#C51918"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.15654 11.2681C4.15654 11.2681 4.54334 12.4515 5.22073 13.112C5.89812 13.7725 6.73552 14.0962 6.73552 14.0962C6.73552 14.0962 7.73293 13.7944 8.29901 13.159C8.86509 12.5236 9.44462 11.2681 9.44462 11.2681L8.12815 10.0047L7.6049 10.5725L6.73552 9.33307L6.00768 10.5725L5.44957 10.0047L4.15654 11.2681Z",
        fill: "white"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.36012 7.41459H4.83278L5.24178 7.03143L4.83278 6.62654H5.36012L5.58278 6.23352L5.80634 6.62654H6.33278L5.94422 7.00711L6.28924 7.41459H5.80634L5.58278 7.82934L5.36012 7.41459Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.84543 7.41459H7.31808L7.72709 7.03143L7.31808 6.62654H7.84543L8.06808 6.23352L8.29164 6.62654H8.81808L8.42953 7.00711L8.77454 7.41459H8.29164L8.06808 7.82934L7.84543 7.41459Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.44995 8.67561H5.92261L6.33161 8.29245L5.92261 7.88756H6.44995L6.67261 7.49454L6.89616 7.88756H7.42261L7.03405 8.26813L7.37907 8.67561H6.89616L6.67261 9.09036L6.44995 8.67561Z",
        fill: "#FECA00"
      })]
    })]
  })]
}));
//# sourceMappingURL=Slovenia.js.map